import React from 'react';
import {
    Row,
    Item,
    VariationItemContainer,
    ActionContainer,
    VariationPriceContainer,
} from 'components/customer/Confirmation/Checkout/Table';
import {formatPrice, Icon} from 'shared/helpers';
import {useJobContext} from 'contexts';
import {PartialJob} from 'shared/types/PartialJob';
import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';

export interface Variation {
    id: string | number;
    room_id?: number;
    room_cab_number?: number;
    type_name?: string;
    comment?: string;
    variation_cost?: number;
    jobBenchtopNumber?: string;
    name?: string;
    removable?: boolean;
    job_cabinet_appliance_id?: number | null;
    product_label?: string;
    detail_label?: string;
}

interface VariationsProps {
    variations: Variation[];
    getName: (variation: Variation) => string | React.JSX.Element;
    deleteAction?: (id: number, cost: number) => () => void;
    restoreAction?: (id: number, cost: number) => () => void;
    isDeleted?: (id: number) => boolean;
}

export const Variations = ({
    variations,
    getName,
    deleteAction,
    restoreAction,
    isDeleted,
}: VariationsProps) => {
    const {job} = useJobContext() as PartialJob;

    return (
        <>
            {variations.map((variation) => {
                return (
                    <Row key={variation.id}>
                        <td>
                            <VariationItemContainer
                                $isDeleted={isDeleted(Number(variation.id))}>
                                <Item>{getName(variation)}</Item>
                            </VariationItemContainer>
                        </td>
                        <td>
                            <VariationPriceContainer>
                                {formatPrice(variation.variation_cost, {})}
                            </VariationPriceContainer>
                        </td>
                        <td>
                            {job.status != JOB_STATUS.PROCESSING &&
                            (variation.removable ?? true) ? (
                                <ActionContainer>
                                    {isDeleted(Number(variation.id)) ? (
                                        <Icon
                                            onClick={restoreAction(
                                                Number(variation.id),
                                                variation.variation_cost
                                            )}
                                            iconName="Button-Rotate-Anti-Clockwise.svg"
                                            title="Restore variation"
                                        />
                                    ) : (
                                        <Icon
                                            onClick={deleteAction(
                                                Number(variation.id),
                                                variation.variation_cost
                                            )}
                                            iconName="Options-Delete.svg"
                                            title="Delete variation"
                                        />
                                    )}
                                </ActionContainer>
                            ) : null}
                        </td>
                    </Row>
                );
            })}
        </>
    );
};
